import { Box, CircularProgress, Divider, FormHelperText, Typography } from '@mui/material';
import { FormikConfig } from 'formik';
import React from 'react';
import Details from '../../../components/Details/Details';
import FilterComponentV2 from '../../../components/TablegridWithFilters/FilterComponent/FilterComponentv2';
import TabsLayout from '../../../components/Tabs/TabsLayout';
import { gemiAFMValidation, gemiBranchValidation } from '../../../lib/fetchers';
import { eliminateOjectNotTruthyValues, matchRefsWithData } from '../../../lib/helperFuncs';
import { EpimelitiriaDictionary, gemiAFMRefs, legalGemiTypes } from '../../../lib/static/details/staticDetails';
import { GemiValidateAFMFields, GemiValidateBranchFields } from '../../../lib/static/filters/filterFields';
import { validateGemiAFMInitialValues, validateGemiBranchInitialValues } from '../../../lib/static/filters/initialValues';
import { gemiAFMValidationSchema, gemiBranchValidationSchema } from '../../../lib/static/filters/ValidationSchema';
import Theme from '../../../Themes/main.theme';

const ValididateGemi = () => {
  const [tab, setTab] = React.useState<number>(0);
  const [data, setData] = React.useState();
  const [dataBranch, setDataBranch] = 
    React.useState<{isBranch: string} | Record<string, never>>({});
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>();

  const onSubmitAFM = async (values: FormikConfig<any>) => {    
    setIsLoading(true);
    try {
      const response = await gemiAFMValidation(eliminateOjectNotTruthyValues(values));
      setError('');
      setData({...response.data,
        legalType: legalGemiTypes[response.data.legalTypeId], 
        isBranch: response.data.isBranch
          ?'NAI'
          :'ΟΧΙ',
        responsibleOrg: EpimelitiriaDictionary[response.data.responsibleOrg]
      });
    } catch (error: any) {
      console.error(error);
      if (error.response.status === 400) {
        setError(error.response.data.message);
      }
    }
    setIsLoading(false);
  };
  
  const onSubmitBranch = async (values: FormikConfig<any>) => {    
    setIsLoading(true);
    try {
      const response = await gemiBranchValidation(eliminateOjectNotTruthyValues(values));
      setError('');
      setDataBranch(response.data);
    } catch (error: any) {
      console.error(error);
      if (error.response.status === 400) {
        setError(error.response.data.message);
      }
    }
    setIsLoading(false);
  };
  
  const details = matchRefsWithData(data, gemiAFMRefs);

  const tabLabels = [
    {
      label: <Typography variant='h4'>Έλεγχος ύπαρξης ΑΦΜ</Typography>,
    },
    {
      label: <Typography variant='h4'>Έλεγχος Υποκαταστήματος</Typography>,
    }
  ];

  const tab1 = <Box my={4} width='100%'>
    <FilterComponentV2
      title='Φίλτρο Αναζήτησης ύπαρξης ΑΦΜ'
      validationSchema={gemiAFMValidationSchema}
      filterFields={GemiValidateAFMFields}
      initialValues={validateGemiAFMInitialValues}
      resetFilters={true}
      changeFilters={filterValues => onSubmitAFM(filterValues)}
      validateOnBlur={false}
    />
    <Box mt={5} >
      {isLoading
        ? <Box sx={{ display: 'flex', justifyContent: 'center'}}>
          <CircularProgress />
        </Box>
        : error
          ? <Typography variant='h4' display='flex'
            justifyContent='center'>
            {error}
          </Typography> 
          : data
            ? <Box height='100%'>
              <Details rows={details}/>
            </Box> 
            : null 
      }
    </Box>
  </Box>; 

  const tab2 = <Box my={4}>
    <FormHelperText sx={{mb: 1}}>
      <Typography variant='subtitle1'>
        Ελέγχει αν υπάρχει ένα ΑΦΜ και ο Αριθμός ΓΕΜΗ και αν αφορά υποκατάστημα στο Μητρώο ΓΕΜΗ.
      </Typography>
    </FormHelperText>
    <FilterComponentV2
      title='Φίλτρο Αναζήτησης ύπαρξης ΑΦΜ'
      validationSchema={gemiBranchValidationSchema}
      filterFields={GemiValidateBranchFields}
      initialValues={validateGemiBranchInitialValues}
      resetFilters={true}
      changeFilters={filterValues => onSubmitBranch(filterValues)}
      validateOnBlur={false}
    />
    <Box mt={5} >
      {isLoading
        ? <Box sx={{ display: 'flex', justifyContent: 'center'}}>
          <CircularProgress />
        </Box>
        : error
          ? <Typography variant='h4' display='flex'
            justifyContent='center'>
            {error}
          </Typography> 
          : Object.values(dataBranch).length > 0
            ? <Box height='100%' display='flex'
              justifyContent='center'>
              <Typography>Ο Αριθμός ΓΕΜΗ </Typography>&nbsp;
              {dataBranch?.isBranch?
                <Typography variant='h4'>αφορά</Typography>
                :<Typography variant='h4'>ΔΕΝ αφορά</Typography>
              }&nbsp;
              <Typography>υποκατάστημα στο Μητρώο ΓΕΜΗ</Typography>
             
            </Box> 
            : null 
      }
    </Box>
  </Box>;
  const tabContent = [
    tab1,
    tab2
  ];

  return (
    <>
      <Box mt={5}>
        <Typography sx={{ my: 2 }} variant='h2'
          color={Theme?.labelColor?.main}>Επιβεβαίωση Στοιχείων από Μητρώο ΓΕΜΗ</Typography>
        <Divider sx={{ mb: 5, border: 1, color: Theme?.dividerColor?.main }} />
        <TabsLayout
          tab={tab}
          setTab={setTab}
          tabLabels={tabLabels}
          tabContent={tabContent}
          resetFilters={() => {
            setData(undefined);
            setDataBranch({});
            setError('');
          }}
        />
      </Box>
    </>
  );
};

export default ValididateGemi;